import React, { createContext, useContext } from "react";
import type { Lang } from "@/i18n/languages";
import { DEFAULT_LANG } from "@/i18n/languages";

type LangContextValue = {
  lang: Lang;
};

const LangContext = createContext<LangContextValue>({ lang: DEFAULT_LANG });

export function LangProvider({
  lang,
  children,
}: {
  lang: Lang;
  children: React.ReactNode;
}) {
  return <LangContext.Provider value={{ lang }}>{children}</LangContext.Provider>;
}

export function useLang(): LangContextValue {
  return useContext(LangContext);
}
